import { useState } from 'react';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'How long does it take to get a custom suit?',
      answer: 'Custom suits typically take 6–8 week turnaround from measurement to delivery. This timeframe ensures proper hand-crafting and quality control. Rush services are available for an additional fee if you need your garment sooner.',
    },
    {
      question: 'Do you offer house calls in my area?',
      answer: 'Yes! We make house and office calls throughout Massachusetts and New England. Our traveling consultants bring fabric samples and take measurements at your location. Contact us to schedule a visit.',
    },
    {
      question: 'How many measurements do you take?',
      answer: 'We take over 30 precise measurements for custom suits to ensure a perfect fit. This includes shoulder width, chest, waist, sleeve length, inseam, and many other critical measurements that off-the-rack clothing cannot accommodate.',
    },
    {
      question: 'Can I see fabric samples before ordering?',
      answer: 'Absolutely! You can visit our Wellesley showroom to see our full fabric collection, or we can mail fabric swatches to your home free of charge. We have 5000+ fabrics available for suits from premium European mills.',
    },
    {
      question: 'Do you offer alterations for existing garments?',
      answer: 'Yes, we provide professional alteration services for all types of garments, whether purchased from us or elsewhere. Our expert tailors can handle everything from simple hemming to complex reconstructions.',
    },
    {
      question: 'What payment methods do you accept?',
      answer: 'We accept all major credit cards, debit cards, cash, and checks. A deposit is typically required when placing your order, with the balance due upon delivery.',
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-600">
            Everything you need to know about our custom tailoring services
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white border border-gray-200 rounded-xl overflow-hidden hover:border-[#C4A962] transition-colors"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <h3 className="text-lg font-semibold text-gray-900 pr-8">
                  {faq.question}
                </h3>
                <i
                  className={`text-2xl text-[#C4A962] transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'ri-subtract-line' : 'ri-add-line'
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 pb-5">
                  <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Help */}
        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">Still have questions?</p>
          <a
            href="tel:781-237-3166"
            className="inline-flex items-center text-[#C4A962] font-semibold hover:text-[#B39952] transition-colors"
          >
            <i className="ri-phone-line mr-2"></i>
            Call us at 781-237-3166
          </a>
        </div>
      </div>

      {/* Structured Data for FAQ */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": faqs.map(faq => ({
            "@type": "Question",
            "name": faq.question,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": faq.answer
            }
          }))
        })}
      </script>
    </section>
  );
};

export default FAQSection;